// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BTC8y5j9Gb4DMnW9eV2I{flex-direction:column;width:100%;max-width:772px;display:flex;overflow:auto}.UyUZErTI3kk78AkVrZQB{width:101px;height:40px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `BTC8y5j9Gb4DMnW9eV2I`,
	"addNumbersButton": `UyUZErTI3kk78AkVrZQB`
};
export default ___CSS_LOADER_EXPORT___;
